import React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';

import { LinkItem } from '@occc-app/design-system';
import {
  Typography,
  ConfirmDialog,
  useAppLayoutContextConsumer,
  Page,
} from '@occc-app/design-system';

import { ScheduleForm } from './components/schedule-form/schedule-form.component';
import {
  MessagingCampaignConfigureLayout,
  ConfigureLayoutProps,
} from './messaging-campaign-configure.layout';
import { TargetForm } from './components/target-form/target-form.component';
import { ConfigureForm } from './components/configure-form/configure-form.component';
import { MessagingCampaignTargetFormProps } from './components/target-form/target-form.types';
import { MessagingCampaignConfigureFormProps } from './components/configure-form/configure-form.types';
import { MessagingCampaignScheduleFormProps } from './components/schedule-form/schedule-form.types';
import { MessagingCampaignTabs } from './messaging-campaign-configure.constants';

import { PAGE_TITLE } from '../../messaging-center.constants';

export type MessagingCampaignConfigurePageProps = {
  layoutProps: ConfigureLayoutProps;
  dialogProps: {
    open: boolean;
    closeModal: () => void;
    title: string;
    onConfirmClick: () => void;
  };
  pageTitle: string;
  subtitle: string;
  configureFormProps: MessagingCampaignConfigureFormProps;
  targetFormProps: MessagingCampaignTargetFormProps;
  scheduleFormProps: MessagingCampaignScheduleFormProps;
  breadcrumbLinks: LinkItem[];
};

export const MessagingCampaignConfigurePage = ({
  layoutProps,
  dialogProps,
  configureFormProps,
  targetFormProps,
  scheduleFormProps,
  breadcrumbLinks,
}: MessagingCampaignConfigurePageProps) => {
  useAppLayoutContextConsumer(breadcrumbLinks);
  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      containerProps={{ variant: 'md' }}
      pageHeaderProps={{ title: layoutProps.title, subtitle: layoutProps.subtitle }}
    >
      <MessagingCampaignConfigureLayout {...layoutProps}>
        <Routes>
          <Route path='' element={<Navigate to={MessagingCampaignTabs.Configure} replace />} />
          <Route
            path={MessagingCampaignTabs.Configure}
            element={<ConfigureForm {...configureFormProps} />}
          />
          <Route
            path={MessagingCampaignTabs.Target}
            element={<TargetForm {...targetFormProps} />}
          />
          <Route
            path={MessagingCampaignTabs.Schedule}
            element={<ScheduleForm {...scheduleFormProps} />}
          />
        </Routes>
      </MessagingCampaignConfigureLayout>

      <ConfirmDialog
        dialogTitle={`Cancel ${dialogProps.title}`}
        open={dialogProps.open}
        confirmButtonText='Yes'
        confirmButtonProps={{
          onClick: dialogProps.onConfirmClick,
        }}
        onClose={dialogProps.closeModal}
      >
        <Typography>
          {`Wait! If you continue, your progress will be lost. Do you still want to cancel?`}
        </Typography>
      </ConfirmDialog>
    </Page>
  );
};
